__webpack_require__.p = "/Klokking-2026-Registration-Beta/";